import { DateTime } from "luxon";

import { PrescriptionMedicationStatus } from "@/Common/Models/Patient/PatientEnums";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

export class MedicationHelper {
    public static isMeidcationReplaced(currentCode: string): boolean {
        return currentCode === PrescriptionMedicationStatus.Augmented || currentCode === PrescriptionMedicationStatus.Reduced;
    }

    public static isMedicationInterrupted(currentCode: string): boolean {
        return currentCode === PrescriptionMedicationStatus.Interrupted;
    }

    public static isMedicationRenewed(currentCode: string): boolean {
        return currentCode === PrescriptionMedicationStatus.Active;
    }

    /**
     * Get DIN with a prefix if DIN exists, or a name if DIN does not exist.
     * @param {string} name
     * @param {string} din drug identification number
     * @returns {string}
     */
    public static getMedicationDinOrName(name: string, din: string): string {
        if (!IsNullOrWhiteSpace(din)) {
            const newDIN = "GEN-DIN:" + din + " ";

            if (name?.length > 2) {
                return newDIN + name.substring(0, 2);
            }

            return newDIN;
        }

        return name ?? "";
    }

    /**
     * Return true if the end date and start date is in conflict with the range between the given dateFrom and dateTo
     * @param startDate a medication's start date
     * @param endDate a medication's end date
     * @param dateFrom
     * @param dateTo
     * @returns {boolean}
     */
    public static isMedicationDateBetweenDateFromAndDateTo(startDate: Date, endDate: Date, dateFrom: Date, dateTo: Date): boolean {
        const getCurrentDateAfterYear = (years: number): Date => DateTime.local().plus({ years }).toJSDate();
        const getParsedDate = (date: Date | string | undefined | null): Date => !!date ? LuxonDateTimeParser.parse(date).toJSDate() : DateTime.local().toJSDate();
        const defaultYearWhenNull: number = 100;

        const parsedDateFrom: Date = !!dateFrom ? dateFrom : getCurrentDateAfterYear(-defaultYearWhenNull);
        const parsedDateTo: Date = !!dateTo ? dateTo : getCurrentDateAfterYear(defaultYearWhenNull);

        return parsedDateFrom <= getParsedDate(endDate) && getParsedDate(startDate) <= parsedDateTo;
    }
}
